import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import AcademicDegreeForm, { AcademicDegreeFormItem } from "../../../../forms/shared/AcademicDegreeForm";
import Controls from "../../../../components/controls/Controls";
import AcademicService from "../../../../services/AcademicService";
import { ITableHeaderProps } from "../../../../components/controls/Table";
import { InputType } from "../../../../components/controls/Input";



interface AcademicDegreeComponentProps {
    AcademicDegreeForm: AcademicDegreeForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: AcademicDegreeFormItem) => void
    onDeleteClick: (e: AcademicDegreeFormItem) => void
    onCancelItem: () => void
}

export default function AcademicDegreeComponent(props: AcademicDegreeComponentProps) {

    const headers: ITableHeaderProps[] = [
        { title: "Título de Especialidade", align: "center", property: "Title", type: "text" },
        { title: "Instituição", align: "center", property: "Institution", type: "text" },
        { title: "Ano de conclusão", align: "center", property: "YearCompletion", type: "text" },
        { title: "Curso", align: "center", property: "Course", type: "text" },
    ]

    const [titleStateOptions, setTitleStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllTitleOptions().then(e => setTitleStateOptions(e))
    }, []);


    return (

        <Grid container spacing={5}>

            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Título de Especialidade"
                    name="Title"
                    placeholder="Selecione"
                    options={titleStateOptions}
                    mandatory={props.AcademicDegreeForm.Title.Mandatory}
                    value={props.AcademicDegreeForm.Title.Value}
                    onChange={(e) => {
                        props.onInputChange("Title", props.AcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Title", props.AcademicDegreeForm, e.target.value);
                    }}
                    error={props.AcademicDegreeForm.Title.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="Institution"
                    label="Instituição"
                    maxLength={80}
                    placeholder="Digite o nome da instituição"
                    mandatory={props.AcademicDegreeForm.Institution.Mandatory}
                    value={props.AcademicDegreeForm.Institution.Value}
                    onChange={(e) => {
                        props.onInputChange("Institution", props.AcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Institution", props.AcademicDegreeForm, e.target.value);
                    }}
                    error={props.AcademicDegreeForm.Institution.Error}
                />
            </Grid>



            <Grid item xs={6} sm={6}>
                <Controls.Input
                    label="Curso"
                    name="Course"
                    maxLength={100}
                    placeholder="Selecione"
                    mandatory={props.AcademicDegreeForm.Course.Mandatory}
                    value={props.AcademicDegreeForm.Course.Value}
                    onChange={(e) => {
                        props.onInputChange("Course", props.AcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Course", props.AcademicDegreeForm, e.target.value);
                    }}
                    error={props.AcademicDegreeForm.Course.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="YearCompletion"
                    label="Ano de conclusão"
                    maxLength={4}
                    type={InputType.NUMERICO}
                    placeholder="Digite o ano de conclusão"
                    mandatory={props.AcademicDegreeForm.YearCompletion.Mandatory}
                    value={props.AcademicDegreeForm.YearCompletion.Value}
                    onChange={(e) => {
                        props.onInputChange("YearCompletion", props.AcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("YearCompletion", props.AcademicDegreeForm, e.target.value);
                    }}
                    error={props.AcademicDegreeForm.YearCompletion.Error}
                />
            </Grid>

            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.AcademicDegreeForm.AcademicDegreeFormItemToEdit.Id > 0 ?
                        <Controls.Button text="Cancelar" type="Error" onClick={props.onCancelItem} /> : null
                    )}

                    {(props.AcademicDegreeForm.AcademicDegreeFormItemToEdit.Id === 0 ?
                        <Controls.Button text="Adicionar" type="Success" onClick={props.onInserOrUpdateItem} />
                        : <Controls.Button text="Salvar" type="Success" onClick={props.onInserOrUpdateItem} />
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Controls.Table
                    headers={headers}
                    actionColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.AcademicDegreeForm.AcademicDegreeFormItemList}
                />
            </Grid>

        </Grid>

    )

}